/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropwinnersconfirmbody3Inputs */

const en_dropwinnersconfirmbody3 = /** @type {(inputs: Dropwinnersconfirmbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each winner gets the message as a Pulsify DM plus a push notification.`)
};

const de_dropwinnersconfirmbody3 = /** @type {(inputs: Dropwinnersconfirmbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Gewinner bekommt die Nachricht als Pulsify-Chat plus Mitteilung.`)
};

/**
* | output |
* | --- |
* | "Each winner gets the message as a Pulsify DM plus a push notification." |
*
* @param {Dropwinnersconfirmbody3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinnersconfirmbody3 = /** @type {((inputs?: Dropwinnersconfirmbody3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinnersconfirmbody3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinnersconfirmbody3(inputs)
	return de_dropwinnersconfirmbody3(inputs)
});
export { dropwinnersconfirmbody3 as "dropWinnersConfirmBody" }